"use client";
import { PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function PortalWeb(props: PropsWithChildren) {
  const { children } = props;

  const [mount, setMount] = useState(false);
  useEffect(() => {
    setMount(true);
  }, []);

  return mount ? createPortal(children, document.body) : null;
}
